import { defaultSounds, SoundService as BaseSoundService } from '@pascal/pascal-core';

defaultSounds.win = null;
defaultSounds.betAccepted = null;
defaultSounds.music.src = 'sounds/background_1.mp3';
defaultSounds.music.loop = true;

const SoundNames = {
  SingleClick: 'SINGLE_CLICK',
  Start: 'START',
  Bomb: 'BOMB',
  BigWin: 'BIG_WIN',
  Timer: 'TIMER',
  CashOut: 'CASH_OUT',
  CorrectStep: 'CORRECT_STEP',
};

class SoundService extends BaseSoundService {
  constructor(options) {
    super({ options });
  }

  click() {
    return this.play(SoundNames.SingleClick);
  }

  start() {
    return this.play(SoundNames.Start);
  }

  cashOut() {
    return this.play(SoundNames.CashOut);
  }

  stopCashOut() {
    return this.stop(SoundNames.CashOut);
  }

  bomb() {
    return this.play(SoundNames.Bomb);
  }

  bigWin() {
    return this.play(SoundNames.BigWin);
  }

  correctStep() {
    return this.play(SoundNames.CorrectStep);
  }

  timer() {
    return this.play(SoundNames.Timer);
  }

  stopTimer() {
    return this.stop(SoundNames.Timer);
  }

  stopBigWin() {
    return this.stop(SoundNames.BigWin);
  }
}

export const soundService = new SoundService([
  {
    name: SoundNames.SingleClick,
    src: 'sounds/singleClick.wav',
    loop: false,
    autoplay: false,
    html5: false,
  },
  {
    name: SoundNames.Start,
    src: 'sounds/GameStart.mp3',
    loop: false,
    autoplay: false,
    html5: false,
  },
  {
    name: SoundNames.CorrectStep,
    src: 'sounds/correctStep_option2.mp3',
    loop: false,
    autoplay: false,
    html5: false,
  },
  {
    name: SoundNames.BigWin,
    src: 'sounds/bigWin.mp3',
    loop: true,
    autoplay: false,
    html5: false,
  },
  {
    name: SoundNames.Timer,
    src: 'sounds/Timer.mp3',
    loop: true,
    autoplay: false,
    html5: false,
  },
  {
    name: SoundNames.CashOut,
    src: 'sounds/Cashout.mp3',
    loop: false,
    autoplay: false,
    html5: false,
  },
  {
    name: SoundNames.Bomb,
    src: 'sounds/Wrongstep_bomb.mp3',
    loop: false,
    autoplay: false,
    html5: false,
  },
]);
